/* eslint-disable no-restricted-properties */

import { createEnv } from "@t3-oss/env-core";
import { z } from "zod/v4";

export const Env = createEnv({
  server: {
    COOKIE_DOMAIN: z.string().min(1),
    NODE_ENV: z.enum(["development", "production"]).optional(),
  },
  runtimeEnv: process.env,
  skipValidation:
    !!process.env.CI || process.env.npm_lifecycle_event === "lint",
});
